import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "action-btns" }
const _hoisted_2 = { class: "team-header-block flex-container justify-space-between" }
const _hoisted_3 = { class: "team-container flex-container" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "feedback received", -1)
const _hoisted_6 = { class: "question-container flex-container align-start" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { class: "survey_prompt" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Q:", -1)
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "feedback-info" }
const _hoisted_14 = { class: "feedback-provider" }
const _hoisted_15 = {
  key: 0,
  class: "pill-tag pill-green"
}
const _hoisted_16 = { class: "feedback" }

import { ref, computed } from "vue";
import { uniq } from "lodash";
import {
  RatingOutcome,
  TeamFeedback,
  MemberFeedback,
  FeedbackQuestion,
} from "@/services/surveyFeedbackService";
import TandemAccordion from "@/components/TandemAccordion.vue";
import FeedbackGroupCheckbox from "@/components/FeedbackGroupCheckbox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackTeamReview',
  props: {
    team: {},
    acceptSelected: { type: Boolean },
    rejectSelected: { type: Boolean }
  },
  emits: ["acceptSelected", "rejectSelected"],
  setup(__props: any, { emit }) {

const props = __props;





const allIds = computed<number[]>(() =>
  props.team.members.flatMap((member) =>
    member.questions.flatMap((question) =>
      question.responses.flatMap(
        (response) => response.sharedTeamMemberRatingId
      )
    )
  )
);
const actionsEnabled = computed(
  () => props.acceptSelected || props.rejectSelected
);
const selectedIds = ref<number[]>([]);
const pushIds = (ids: number[]) => {
  selectedIds.value = uniq(selectedIds.value.concat(ids));
};
const removeIds = (ids: number[]) =>
  (selectedIds.value = selectedIds.value.filter((id) => !ids.includes(id)));

const handleAccept = () => {
  emit("acceptSelected", selectedIds.value.concat());
  selectedIds.value = [];
};
const handleReject = () => {
  emit("rejectSelected", selectedIds.value.concat());
  selectedIds.value = [];
};

const getMemberFeedbackIds = (member: MemberFeedback): number[] =>
  member.questions.flatMap((question) =>
    question.responses.flatMap((response) => response.sharedTeamMemberRatingId)
  );

const getQuestionFeedbackIds = (question: FeedbackQuestion): number[] =>
  question.responses.map((response) => response.sharedTeamMemberRatingId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.acceptSelected)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleAccept,
            class: "btn btn-blue"
          }, " Accept Selected "))
        : _createCommentVNode("", true),
      (_ctx.rejectSelected)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: handleReject,
            class: "btn btn-burg"
          }, " Reject Selected "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (actionsEnabled.value)
          ? (_openBlock(), _createBlock(FeedbackGroupCheckbox, {
              key: 0,
              "group-ids": allIds.value,
              "selected-ids": selectedIds.value,
              onChecked: pushIds,
              onUnchecked: removeIds,
              class: "feedback-check"
            }, null, 8, ["group-ids", "selected-ids"]))
          : _createCommentVNode("", true),
        _createElementVNode("h2", null, _toDisplayString(_ctx.team.name), 1)
      ]),
      _renderSlot(_ctx.$slots, "buttons")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.members, (member) => {
      return (_openBlock(), _createBlock(TandemAccordion, {
        key: member.name,
        tooltip: `Toggle feedback for ${member.name}`,
        "open-by-default": ""
      }, {
        "accordion-checkbox": _withCtx(() => [
          _createElementVNode("label", null, [
            _createElementVNode("span", _hoisted_4, " Select all feedback received for " + _toDisplayString(member.name), 1),
            (actionsEnabled.value)
              ? (_openBlock(), _createBlock(FeedbackGroupCheckbox, {
                  key: 0,
                  "group-ids": getMemberFeedbackIds(member),
                  "selected-ids": selectedIds.value,
                  onChecked: pushIds,
                  onUnchecked: removeIds,
                  class: "feedback-check"
                }, null, 8, ["group-ids", "selected-ids"]))
              : _createCommentVNode("", true)
          ])
        ]),
        label: _withCtx(() => [
          _createElementVNode("b", null, _toDisplayString(member.name), 1),
          _createTextVNode(" — "),
          _hoisted_5
        ]),
        content: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.questions, (question) => {
            return (_openBlock(), _createElementBlock("div", {
              key: question.question,
              class: "question-block"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", null, [
                  _createElementVNode("span", _hoisted_7, " Select all feedback received for " + _toDisplayString(member.name) + " for the question: “" + _toDisplayString(question.question) + "” ", 1),
                  (actionsEnabled.value)
                    ? (_openBlock(), _createBlock(FeedbackGroupCheckbox, {
                        key: 0,
                        "group-ids": getQuestionFeedbackIds(question),
                        "selected-ids": selectedIds.value,
                        onChecked: pushIds,
                        onUnchecked: removeIds,
                        class: "feedback-check"
                      }, null, 8, ["group-ids", "selected-ids"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(),
                  _createElementVNode("i", {
                    innerHTML: question.question
                  }, null, 8, _hoisted_10)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.responses, (response) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: response.sharedTeamMemberRatingId,
                  class: "feedback-container flex-container align-start"
                }, [
                  _createElementVNode("label", null, [
                    _createElementVNode("span", _hoisted_11, " Select feedback from " + _toDisplayString(response.from) + " for " + _toDisplayString(member.name) + ": “" + _toDisplayString(response.response) + "” ", 1),
                    (actionsEnabled.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          value: response.sharedTeamMemberRatingId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedIds).value = $event)),
                          class: "feedback-check"
                        }, null, 8, _hoisted_12)), [
                          [_vModelCheckbox, selectedIds.value]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, [
                      _createElementVNode("i", null, [
                        _createElementVNode("b", null, _toDisplayString(response.from) + "‘s", 1),
                        _createTextVNode(" feedback:")
                      ]),
                      (response.outcome === _unref(RatingOutcome).Released)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Released"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_16, " “" + _toDisplayString(response.response) + "” ", 1)
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["tooltip"]))
    }), 128))
  ]))
}
}

})